import { Component, ViewChild } from '@angular/core';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ModalTravelManagementComponent } from '../../../shared/modals/modal-travel-management/modal-travel-management.component';
import { Title } from '@angular/platform-browser';
import {
  BookingItem,
  BookingItemMinimal,
  Payment,
  TravelBookingItemMinimal,
  TravelDonation,
  TravelDonationsResponse,
  TravelItem,
  TravelItemWithVisibilityMetadata,
} from '../../../api/models';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { SlugifyPipe } from '../../../shared/pipes/slugify.pipe';
import { BookingService, TravelService } from '../../../api/services';
import { environment } from '../../../../environments/environment';
import { Table, TableLazyLoadEvent } from 'primeng/table';
import { BookingControllerTravelBookings$Params } from '../../../api/fn/booking/booking-controller-travel-bookings';
import { FormControl, FormGroup } from '@angular/forms';
import { debounce, debounceTime, distinctUntilChanged } from 'rxjs';
import { enumUserRole } from '../../../shared/utils/enum-user-role';
import { enumPaymentStatus } from '../../../shared/utils/enum-payment-status';
import { TravelControllerGetTravelDonations$Params } from '../../../api/fn/travel/travel-controller-get-travel-donations';

@Component({
  selector: 'app-travel-management',
  templateUrl: './travel-management.component.html',
  styleUrl: './travel-management.component.scss',
})
export class TravelManagementComponent {
  // @ViewChild('dt1') table?: Table;
  activeIndex = 0;
  travelManagementRef: DynamicDialogRef | undefined;
  travel?: TravelItemWithVisibilityMetadata;
  bookings: TravelBookingItemMinimal[] = [];
  travel_id?: number;
  dates: string[] = [];
  environmentMediaUrl = environment.mediaUrl;
  rangeDates?: Date[] | undefined;
  progressValue?: number;
  totalRecords: number = 0;
  total?: number;
  earned?: number;
  to_earn?: number;
  loading = false;
  loading_page = false;
  enumUserRole = enumUserRole;
  enumPaymentStatus = enumPaymentStatus;
  donations: TravelDonation[] = [];
  frmFilter = new FormGroup({
    range_dates: new FormControl<Date[] | undefined>(undefined),
    identifier: new FormControl<string | undefined>(undefined),
    created_by: new FormControl<string | undefined>(undefined),
    created_by_account_holder: new FormControl<string | undefined>(undefined),
    stato: new FormControl<string | undefined>(undefined),
  });

  constructor(
    public dialogService: DialogService,
    private title: Title,
    private router: Router,
    private slugifyPipe: SlugifyPipe,
    private bookingService: BookingService,
    private ar: ActivatedRoute,
    private travelService: TravelService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService
  ) {}
  first: number = 0; // indice iniziale
  rows: number = 2; // quante card per pagina

  pagedBookings: TravelBookingItemMinimal[] = []; // prenotazioni filtrate per pagina

  onPageChange(event: any) {
    this.first = event.first;
    this.rows = event.rows;
    this.updatePagedBookings();
  }
  updatePagedBookings() {
    this.pagedBookings = this.bookings.slice(
      this.first,
      this.first + this.rows
    );
  }
  customer_pays_fees() {
    return this.total ? this.total * 0.03 : 0;
  }
  customer_pays_feesEarned() {
    return this.earned ? this.earned * 0.03 : 0;
  }
  customer_pays_feesTo_earn() {
    return this.to_earn ? this.to_earn * 0.03 : 0;
  }
  totalWithCustomer_pays_fees() {
    return this.total ? this.total + this.customer_pays_fees() : 0;
  }

  ngOnInit() {
    this.title.setTitle('SocialTravels - Gestione del viaggio');
    this.ar.params.subscribe((p: Params) => {
      if (p) {
        //this.loading = true;
        this.travel_id = p['travel_id'];
        this.getOneTravel();
        this.getAllBookings({ first: this.first, rows: this.rows });
        this.getAllDonation();
      }
    });

    this.frmFilter.valueChanges
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe(() => {
        this.first = 0;
        this.getAllBookings({ first: this.first, rows: this.rows });
        this.getAllDonation();
      });
  }
  getAllDonation() {
    const dates = this.frmFilter.get('range_dates')?.value;
    const params: TravelControllerGetTravelDonations$Params = {
      id: this.travel_id!,
    };

    this.loading = true;
    this.travelService.travelControllerGetTravelDonations(params).subscribe({
      next: (res) => {
        this.donations = res.data.list;
      },
    });
  }
  totalDonated(donations: TravelDonation[]) {
    return donations.reduce(
      (acc: number, d: TravelDonation) => (acc += d.payment.amount),
      0
    );
  }

  getOneTravel() {
    this.loading_page = true;
    this.travelService
      .travelControllerGetTravel({ id: this.travel_id! })
      .subscribe({
        next: (res) => {
          this.loading = false;
          this.travel = res.data;
          this.progressValue =
            (this.travel?.availability?.booked! /
              this.travel?.availability?.max!) *
            100;
          this.dates.push(res.data.from_date);
          this.dates.push(res.data.to_date);
          this.loading_page = false;
          //this.setBreadcrumb();
        },
      });
  }

  getAllBookings(event: TableLazyLoadEvent) {
    const dates = this.frmFilter.get('range_dates')?.value;
    const params: BookingControllerTravelBookings$Params = {
      limit: +event.rows!,
      skip: +event.first!,
      travel_id: this.travel_id!,
    };
    if (this.frmFilter.get('created_by')?.value != undefined) {
      params.query = this.frmFilter.get('created_by')!.value!;
    }
    if (this.frmFilter.get('identifier')?.value != undefined) {
      params.identifier = this.frmFilter.get('identifier')?.value!;
    }
    if (dates && dates != undefined) {
      params.from_date = dates ? dates[0].toISOString() : undefined;
      params.to_date = dates ? dates[1].toISOString() : undefined;
    }
    this.loading = true;
    this.bookingService.bookingControllerTravelBookings(params).subscribe({
      next: (res) => {
        this.bookings = res.data.list;
        this.totalRecords = res.data.count;
        this.total = res.data.earnings.total;
        this.earned = res.data.earnings.earned;
        this.to_earn = res.data.earnings.to_earn;
        this.loading = false;
      },
    });
  }

  openTravelManagementModal(identifier: string) {
    this.travelManagementRef = this.dialogService.open(
      ModalTravelManagementComponent,
      {
        header: 'Dettaglio pratica',
        width: '70%',
        styleClass: 'modal-res',
        data: {
          idnt: identifier,
        },
      }
    );
    this.travelManagementRef.onClose.subscribe(() => {
      this.first = 0;
      this.getAllBookings({ first: this.first, rows: this.rows });
    });
  }

  goToCheckout() {
    const slugifyName = this.slugifyPipe.transform(this.travel!.name);
    this.router.navigate(
      ['/viaggi-di-gruppo/join', slugifyName, this.travel!.id],
      { queryParams: { 'third-party-booking': true } }
    );
  }

  confirmDelete(id: string) {
    this.confirmationService.confirm({
      message: 'Vuoi eliminare questa prenotazione?',
      header: 'Eliminazione',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sì',
      rejectLabel: 'Annulla',
      acceptButtonStyleClass: 'bg-dialog p-button-sm',
      rejectButtonStyleClass: 'p-button-outlined p-button-sm mr-2',
      accept: () => {
        this.bookingService
          .bookingControllerDeleteBooking({ booking_identifier: id })
          .subscribe({
            next: (res) => {
              this.messageService.add({
                severity: 'success',
                summary: 'Eliminazione',
                detail: 'Prenotazione eliminata con successo.',
              });
              this.first = 0;
              this.getAllBookings({ first: this.first, rows: this.rows });
            },
            error: (err) => {
              this.messageService.add({
                severity: 'error',
                summary: 'Eliminazione',
                detail:
                  'Impossibile eliminare la prenotazione perchè uno o più pagamenti sono già stati ricevuti.',
              });
            },
          });
      },
    });
  }

  downloadFinancialReport() {
    this.bookingService
      .bookingControllerDownloadFinancialReport({
        travel_id: this.travel_id!,
      })
      .subscribe({
        next: (response) => {
          const url = window.URL.createObjectURL(response);
          const a = document.createElement('a');
          a.style.display = 'none';
          a.href = url;
          a.download = `${this.travel!.name}_financial_report.xlsx`;
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
          a.remove();
        },
        error: async (error) => {
          this.messageService.add({
            severity: 'error',
            icon: 'pi pi-times',
            summary: 'Impossibile scaricare il report.',
            detail:
              'Si è verificato un errore durante la generazione del report.',
          });
        },
      });
  }

  sumPayments(b: Payment[]) {
    return b.reduce((acc: number, p: Payment) => (acc += p.amount), 0);
  }
}
